export default "__VITE_ASSET__GAmP4b6h__"